import * as React from "react";
import * as ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import theme from "./theme";
import en from "./i18n/en.json";
import sk from "./i18n/sk.json";
import tw from "./i18n/tw.json";
import it from "./i18n/it.json";
import tr from "./i18n/tr.json";
import es from "./i18n/es.json";
import el from "./i18n/el.json";
import cs from "./i18n/cs.json";


import { Talkr } from "talkr";
import InvitationDialog from "./InvitationDialog";
import WeddingBefore6pmDialog from "./WeddingBefore6pmDialog";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PalenkaDialog from "./palenkaDialog";
import ThankYouDialog from "./thankYouDialog";
import LivestreamPage from "./LivestreamPage";
import TeaPage from "./TeaPage";
import config from "./config";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <Talkr languages={{ en, sk, tw, it, tr, es, el, cs }} defaultLanguage="en">
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path={config.uripaths.weddingPartyAfter6PMPath}
            element={
              <>
                <InvitationDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.weddingPartyBefore6PMPath}
            element={
              <>
                <WeddingBefore6pmDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.palenkaPath}
            element={
              <>
                <PalenkaDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.thankYouPath}
            element={
              <>
                <ThankYouDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.livestreamPath}
            element={<LivestreamPage />}
          />
          <Route
            path={config.uripaths.teaPath}
            element={<TeaPage />}
          />
          <Route
            path="*"
            element={
              <>
                <App />
              </>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </Talkr>
);
